import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled from 'styled-components'

export const StyledRetouchingRevisionDownload = styled(Flexbox)`
    & > p {
        max-width: 365px;
    }
`
